import { UserRow } from "../../Show/Show";

export function transformUserRowToResource(user: UserRow) {
  return {
    id: user.id,
    type: "users",
    attributes: {
      name: user.name,
      email: user.email,
      phone: user.phone || "",
      title: user.title || "",
      "user-type": user.userType || "",
      roles: user.roleIds.map((id, index) => ({
        id,
        name: user.roleNames.split(",")[index]?.trim() || "",
      })),
    },
    relationships: {
      teams: {
        data: user.teamId?.map((id) => ({
          id,
          type: "teams",
        })) || [],
      },
    },
  };
}